import { render, staticRenderFns } from "./sliderbar.vue?vue&type=template&id=58559823&"
import script from "./sliderbar.vue?vue&type=script&lang=js&"
export * from "./sliderbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports